import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'CollapseIcon',
  viewBox: '0 0 448 512',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424zM135.6 238.5c-4.8 4.5-7.6 10.9-7.6 17.5s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9L212.5 280l83.5 0 128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-83.5 0 91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128z"
      />
    </svg>
  ),
});
